import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "w-[48px] h-[48px] rounded-md bg-darkGray flex items-center justify-center shrink-0 font-sm font-medium" }
const _hoisted_2 = { class: "bg-white min-w-[120px] lg:min-w-[281px] h-[48px] md:my-0 my-2 flex items-center justify-start px-6 text-sm font-medium rounded-md md:ml-5" }


import DeleteItemButton from './DeleteItemButton.vue';


export default {
  __name: 'MedicationItem',
  props: {
    id: {
        type: Number,
        required: true,
    },
    field: {
        type: Object,
        required: true,
    },
},
  emits: ['removeItem'],
  setup(__props, { emit }) {

const props = __props;





const remove = () => {
    emit('removeItem', props.id);
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps(_ctx.$attrs, { class: "flex flex-col my-8 md:mt-4 md:mb-0 md:flex-row md:items-center md:justify-start" }), [
    _createElementVNode("p", _hoisted_1, _toDisplayString(__props.id + 1), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.field.title), 1),
    (__props.field.variants === 'custom')
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          class: "border-none h-[48px] w-full md:max-w-[200px] md:ml-5 !mt-0 mb-2 md:mb-0 text-sm font-medium",
          type: "text",
          placeholder: "Wpisz ilość/gramaturę",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((__props.field.selectedVariant) = $event))
        }, null, 512)), [
          [_vModelText, __props.field.selectedVariant]
        ])
      : _createCommentVNode("", true),
    _createVNode(DeleteItemButton, {
      onDeleteItem: remove,
      id: __props.id
    }, null, 8, ["id"])
  ], 16))
}
}

}